import React from "react";
import RadioGroup from "@material-ui/core/RadioGroup";
import Grid from "@material-ui/core/Grid";
import FormLabel from "@material-ui/core/FormLabel";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import {StyledRadio} from "../../../../../utils/designComponents/StyledRadio";
import Typography from "@material-ui/core/Typography";


const smallFont = {fontSize: 15};

export default function InstrumentSelect({instrument, setInstrument}) {
    return (
        <RadioGroup
            row
            aria-label="instrument"
            name="instrument"
            value={instrument}
            onChange={(ev) => {
                setInstrument(ev.target.value);
            }}
        >
            <Grid container>
                <Grid item xs={4}>
                    <FormLabel><Typography style={smallFont}>Instrument:</Typography></FormLabel>
                </Grid>
                <Grid item xs={4}>
                    <FormControlLabel value="stock" control={<StyledRadio/>}
                                      label={<Typography style={smallFont}>stock</Typography>}/>
                </Grid>
                <Grid item xs={4}>
                    <FormControlLabel value="option" control={<StyledRadio/>}
                                      label={<Typography style={smallFont}>option</Typography>}/>
                </Grid>
            </Grid>
        </RadioGroup>
    );
}